import React from "react";
import { View, Text, StyleSheet, Pressable } from "../platformComponents";
import { i18nCrossUtil } from "@adgm/libs";

const colors = {
  white: "#FFFFFF",
  orange: "#F17E00",
};

const typography = {
  regular: {
    fontSize: 14,
    lineHeight: 24,
    fontFamily: "DINPro-Regular",
  },
};

interface StakingComplianceProps {
  onAcknowledge?: () => void;
}
export const StakingCompliance: React.FC<StakingComplianceProps> = ({ onAcknowledge }) => {
  const crossInt = i18nCrossUtil.t();

  return (
    <View style={styles.content}>
      <Text style={styles.agreementText}>
        {crossInt["staking.compliance.agreement.prefix"]}
        <Pressable onPress={() => onAcknowledge && onAcknowledge()}>
          <Text style={styles.linkText}>
            {crossInt["yield.services.risk.disclosure.statement"]}
          </Text>
        </Pressable>

        <Text style={styles.agreementText}>{crossInt["staking.compliance.agreement.suffix"]}</Text>
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  content: {
    maxWidth: 480,
    alignSelf: "center",
  },
  agreementText: {
    ...typography.regular,
    color: colors.white,
  },
  linkText: {
    ...typography.regular,
    color: colors.orange,
    textDecorationLine: "underline",
  },
});
